<template>
    <common-layout>
        <div class="LearningNow">
            <div class="header">
                <span class="txt">当前学习</span>
            </div>
            <div class="cursor_list" v-loading="loading">
                <el-empty style="width:100%;" v-if="archivesItem.length==0" description="暂无正在学习的课程"></el-empty>
                <learning-details v-else :d-height="dHeight" class="cursor_item" v-for="(item,index) in archivesItem" :key="index" :cursorDetail="item" v-on="$listeners" @setEqual="getEqual"></learning-details>
            </div>
        </div>
    </common-layout>
    
</template>
<script>
import CommonLayout from '@/components/LearningCenterComponents/Common'
import LearningDetails from "@/components/LearningDetails"
import { studyProfile } from '@/api/user'
export default {
    components:{
        CommonLayout,
        LearningDetails
    },
    data(){
        return {
            archivesItem:[],
            loading:false,
            dHeight:0
        }
    },
    mounted(){
        if(this.$store.getters.courseId){
            // this.chapterStudyRecord({
            //     traineeId:this.$store.getters.userId,
            //     courseId:this.$store.getters.courseId
            // })
            this.getStudyProfile({
                // year:(new Date().getFullYear()),
                courseId:this.$store.getters.courseId
            })
        }
        
    },
    methods:{
        getStudyProfile(data){
            this.loading = true
            studyProfile(data).then(res=>{
                this.archivesItem = res.data.map(v=>{
                    return {...v,endTimeS:v.endTime.split(' ')[0]}
                })
                this.loading = false
            }).catch(()=>{
                this.loading = false
            })
        },
        getEqual(h){
            this.dHeight = (this.dHeight<h?h:this.dHeight)
        }
    }
}
</script>
<style lang="scss" scoped>
.LearningNow{
    padding:30px;
    .header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 30px;
        .txt{
            font-size: 20px;
            font-weight: bold;
            color: #3964E6;
        }
    }
}
.cursor_list{
    display: flex;
    flex-wrap: wrap;
    .cursor_item{
        width: 50%;
    }
}
</style>